import { app, translate } from "../app"
import { Container } from "./container"
import { languages } from "../locale"
import { useAnimateOnScroll } from "./useAnimateOnScroll"
import { SplitText } from "./splittext"

import {
  Facebook,
  FacebookMessenger,
  Telegram,
  Whatsapp,
  WhatsappSquare,
  Envelope,
  Instagram,
  Tiktok,
  Youtube,
  XTwitter,
  WifiCalling
} from "./icons"

export function BlockChannels(props: { block: BlockChannels }) {
  const { block } = props
  useAnimateOnScroll()
  const isRTL = languages[app.locale]?.rtl

  return (
    <Container block={block} className={`${isRTL ? 'rtl' : ''} !pt-8 sm:!pt-10 md:!pt-12 !pb-2 sm:!pb-4 md:!pb-6`}>
      <div className="flex flex-col">
        {block.title && <h1 className={`!mt-0 fade-up-0 font-inter text-[44px] font-bold leading-[56px] title text-center mb-6`} data-animation="animate__fadeInUp"><SplitText text={translate(block.title)} /></h1>}
        {block.subtitle && <h2 className={`fade-up-1 text-neutral-icon font-inter text-[20px] font-normal leading-[32px] text-center mt-0 mb-6`} data-animation="animate__fadeInUp"><SplitText text={translate(block.subtitle)} /></h2>}
        <div className="channels-icons flex flex-row flex-wrap items-center justify-center gap-6 md:gap-8 w-full max-w-full mx-auto md:mt-6 md:mb-2">
          {socialMediaData.map(({ key, Icon, ariaLabel, isMail }) => (
            block[key] ? (
              <a
                key={key}
                href={isMail ? `mailto:${translate(block[key])}` : translate(block[key])}
                className="icon-only-link"
                data-key={key}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={ariaLabel}
              >
                <Icon className="icon-only-svg" />
              </a>
            ) : null
          ))}
        </div>
      </div>
    </Container>
  )
}

const socialMediaData = [
  {
    key: 'fb_link',
    Icon: Facebook,
    ariaLabel: 'Facebook',
    displayTextKey: 'fb',
  },
  {
    key: 'fbmess_link',
    Icon: FacebookMessenger,
    ariaLabel: 'Facebook Messenger',
    displayTextKey: 'fbmess',
  },
  {
    key: 'whatsapp_link',
    Icon: Whatsapp,
    ariaLabel: 'WhatsApp',
    displayTextKey: 'whatsapp',
  },
  {
    key: 'email_link',
    Icon: Envelope,
    ariaLabel: 'Email',
    displayTextKey: 'email',
    isMail: true,
  },
  {
    key: 'instagram_link',
    Icon: Instagram,
    ariaLabel: 'Instagram',
    displayTextKey: 'instagram',
  },
  {
    key: 'tiktok_link',
    Icon: Tiktok,
    ariaLabel: 'TikTok',
    displayTextKey: 'toktok',
  },
  {
    key: 'telegram_link',
    Icon: Telegram,
    ariaLabel: 'Telegram',
    displayTextKey: 'telegram',
  },
  {
    key: 'whatsappc_link',
    Icon: WhatsappSquare,
    ariaLabel: 'WhatsApp Channel',
    displayTextKey: 'whatsappc',
  },
  {
    key: 'youtube_link',
    Icon: Youtube,
    ariaLabel: 'Youtube',
    displayTextKey: 'youtube',
  },
  {
    key: 'X_link',
    Icon: XTwitter,
    ariaLabel: 'X',
    displayTextKey: 'X',
  },
  {
    key: 'facetime_link',
    Icon: WifiCalling,
    ariaLabel: 'Facetime',
    displayTextKey: 'facetime',
  }
]